import { useContext } from "react";
import LoadingScreenContext from "../contexts/LoadingScreenContext";

const useLoadingHook = () => useContext(LoadingScreenContext);

export default useLoadingHook;
